<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/basic/user',title:'系统管理'},{title:'流程管理'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <!--表单-->


            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="流程定义的key">
							    <el-input clearable v-model="q.defkeyLike"></el-input>
							</el-form-item>
							<el-form-item label="流程名称">
							    <el-input clearable v-model="q.nameLike"></el-input>
							</el-form-item>
							<el-form-item label="版本号">
							    <el-input clearable v-model="q.version"></el-input>
							</el-form-item>
							<el-form-item label="描述">
							    <el-input clearable v-model="q.desLike"></el-input>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="流程类型">
										<brselect clearable category="progress_type" :v="q.progresstype" v-model="q.progresstype"></brselect>
									</el-form-item>
									<el-form-item label="可用标志">
										<brselect clearable category="shifou_keyong" :v="q.delflag" v-model="q.delflag"></brselect>
									</el-form-item>
								</div>
							</div>
                        </el-collapse-transition>
                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="handleEdit">新建流程</el-button>
						</div>
					</div>
                </div>
            </div>



            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        stripe
						border
                        style="width: 100%"
                >
                    <el-table-column
                            prop="progresstype"
                            label="业务类别"
                            width="180">
                        <template slot-scope="scope">
                            <dictname category="progress_type" :v="scope.row.progresstype"/>
                        </template>
                    </el-table-column>
                        <el-table-column
                                prop="defkey"
                                label="流程定义的key"
								:show-overflow-tooltip="true"
                                width="200">
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="流程名称"
								:show-overflow-tooltip="true"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="version"
                                label="版本号"
								:show-overflow-tooltip="true"
                                width="90">
                        </el-table-column>
                        <el-table-column
                                prop="des"
                                label="描述"
								:show-overflow-tooltip="true"
                                min-width="190">
                        </el-table-column>
                        <el-table-column
                                prop="cucode"
                                label="创建人编码"
								:show-overflow-tooltip="true"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
                                label="创建人名称"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                label="创建时间"
								:show-overflow-tooltip="true"
                                width="160">
                        </el-table-column>
                        <el-table-column
                                prop="lucode"
                                label="最后更新人编码"
                                width="160">
                        </el-table-column>
                        <el-table-column
                                prop="ldate"
                                label="最后更新时间"
								:show-overflow-tooltip="true"
                                width="160">
                        </el-table-column>
                        <el-table-column
                                prop="delflag"
                                label="可用标志"
								:show-overflow-tooltip="true"
                                width="90">
                        </el-table-column>


                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="220"
                    >
                        <template slot-scope="scope">
                            <el-button
                                    class="h-tableLink h-btn"
                                    @click="copeProdef(scope.row)">复制流程</el-button>
                            <el-button
                                    class="h-tableLink h-btn"
                                    @click="handleEdit(scope.row)">编辑</el-button>
                            <el-button
                                    class="h-tableLink h-btn"
                                    @click="deleteDef(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                    <pagination :page="q" @query="query" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    export default {
        components: {},
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                //查询属性
                q: {
                    pageSize:20,
                    pageNo:1,
                    total:0,
                },
                //表单
                f:{
                    id:null,
                    defkey:null,
                    name:null,
                    version:null,
                    des:null,
                    cucode:null,
                    cuname:null,
                    cdate:null,
                    lucode:null,
                    ldate:null,
                    delflag:null,
                },
                //table列表
                tableData: [],
                //操作标志
                optflag:'save',
            }
        },
        created() {
            this.query();
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            query(p) {
                ss.prodefservice.page(this.q).then(rd=>{
                    this.q.total = rd.total
                    this.tableData = rd.records;
                })
            },
            handleFilter() {
                this.query();
            },
            deleteDef(obj){
                this.$msg.confirm("确认删除？",()=>{
                    ss.prodefservice.deletebyid(obj.id).then(rd=>{
                        this.query()
                    })
                })
            },
            copeProdef(obj){
                ss.prodefservice.copeProdef(obj.id).then(rd=>{
                    this.query()
                })
            },
            handleEdit(row,f){
                var url = "/process/BscProProdefFlower"
                if(row){

                    // this.$router.push({path:url,query: {id:row.id,optflag:'update'}})

                    let routeData = this.$router.resolve({
                        path: url,
                        query: {id:row.id,optflag:'update'}
                    });
                    window.open(routeData.href, '_blank');
                }else{
                    // this.$router.push({path:url,query: {optflag:'insert'}})

                    let routeData = this.$router.resolve({
                        path: url,
                        query: {optflag:'insert'}
                    });
                    window.open(routeData.href, '_blank');
                }

            }
        }
    }
</script>
